import { updatesData } from '@/mocks/home';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[900px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-100">更新动态</h2>
          <p className="text-sm text-foreground-500 mt-3">最新上线的影视内容与平台动态</p>
        </div>
        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-200/60 hidden sm:block"></div>
          <div className="space-y-0">
            {updatesData.map((item, i) => (
              <div key={i} className="flex gap-4 py-4 border-b border-background-200/30 last:border-b-0">
                <div className="hidden sm:flex flex-shrink-0 flex-col items-center pt-0.5">
                  <div className="w-[10px] h-[10px] rounded-full bg-primary-500 flex-shrink-0"></div>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex flex-wrap items-center gap-2 mb-1.5">
                    <span className="text-xs text-foreground-500 font-medium">{item.date}</span>
                    <span className={`px-2 py-0.5 rounded text-[10px] font-medium whitespace-nowrap ${
                      item.tag === '热播更新' || item.tag === '最新剧集' ? 'bg-primary-500/15 text-primary-400' :
                      item.tag === '完结撒花' || item.tag === '独家内容' ? 'bg-accent-500/15 text-accent-400' :
                      item.tag === '新剧上线' || item.tag === '韩剧热播' ? 'bg-secondary-500/15 text-secondary-400' :
                      'bg-background-200/50 text-foreground-500'
                    }`}>{item.tag}</span>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-100">{item.title}</h3>
                  <p className="text-xs text-foreground-500 mt-1 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}